import { render, staticRenderFns } from "./AppointmentsAdminRow.vue?vue&type=template&id=6db128f6&"
import script from "./AppointmentsAdminRow.vue?vue&type=script&lang=js&"
export * from "./AppointmentsAdminRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports